import clsx from "clsx";

import { KEYS } from "@excalidraw/common";

import { ToolButton } from "./ToolButton";
import { captureIcon } from "./icons";

import type { AppClassProperties } from "../types";

import "./ToolIcon.scss";

type CaptureIconProps = {
  title?: string;
  name?: string;
  onChange?(): void;
  app: AppClassProperties;
  isMobile?: boolean;
};

export const CaptureButton = (props: CaptureIconProps) => {
  return (
    <ToolButton
      className={clsx("Shape", { fillable: false })}
      type="radio"
      icon={captureIcon}
      name="open-capture-dialog"
      checked={false} // This is handled by the app state
      title={`${props.title} — H`}
      keyBindingLabel={!props.isMobile ? KEYS.H.toLocaleUpperCase() : undefined}
      aria-label={`${props.title} — H`}
      aria-keyshortcuts={KEYS.H}
      data-testid={`toolbar-capture`}
      onPointerDown={({ pointerType }) => {
        props.app.setActiveTool({
          type: "hand",
        });
      }}
      onChange={() => props.onChange?.()}
    />
  );
};
